<template lang="pug">
Tabs.ticket-hub
    //- contains-table: a panel card is flush (body padding 0) and its content
    //- carries the spacing, the way every paginated list in the admin is built.
    el-card.contains-table(shadow="always")
        time-entry-list(scope="cms")
</template>

<script>
import Tabs from '@/extensions/communication/views/Partials/Tabs';
import TimeEntryList from '@/extensions/tickets/views/TimeEntryList';

/**
 * The shop's own booked times. `/tickets/times` keeps the message hub's Tickets
 * tab marked, so this needs no tab and no sidebar entry of its own — and the
 * two can never fall out of sync.
 */
export default {
    name: 'CmsTimeEntryList',
    components: {
        Tabs,
        'time-entry-list': TimeEntryList,
    },
};
</script>
